import { Link, useLocation, useNavigate } from 'react-router-dom';
import { hasModule } from '../modules';

export default function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const isActive = (path) => path === '/'
    ? location.pathname === '/'
    : location.pathname === path || location.pathname.startsWith(path + '/');

  const navItems = [
    { path: '/', label: 'Ana Sayfa', icon: '🏠' },
    { path: '/customers', module: 'customers', label: 'Müşteriler', icon: '👥' },
    { path: '/crm/pipeline', module: 'crm', label: 'Satış Hunisi', icon: '💼' },
    { path: '/crm/tasks', module: 'crm', label: 'Görevler', icon: '☑️' },
    { path: '/products', module: 'products', label: 'Ürün/Hizmetler', icon: '📦' },
    { path: '/quotes', module: 'quotes', label: 'Teklifler', icon: '📄' },
    { path: '/hakedisler', module: 'hakedis', label: 'Hakedişler', icon: '✅' },
    { path: '/inventory', module: 'inventory', label: 'Envanter', icon: '📊' },
    { path: '/locations', module: 'inventory', label: 'Depolar', icon: '🏬' },
    { path: '/assemblies', module: 'bom', label: 'Montaj (BOM)', icon: '🧩' },
    { path: '/product-equivalencies', module: 'bom', label: 'Eşdeğer Ürünler', icon: '🔗' },
    { path: '/sourcing', module: 'sourcing', label: 'Tedarik', icon: '🔎' },
    { path: '/purchase-orders', module: 'purchase_orders', label: 'Satın Alma', icon: '🧾' },
  ];

  const adminItems = [
    { path: '/users', label: 'Kullanıcılar', icon: '👤' },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <div className="w-64 bg-white shadow-md flex flex-col">
        <div className="p-6 border-b">
          <h1 className="text-xl font-bold text-blue-600">Teklif Sistemi</h1>
          <p className="text-xs text-gray-500 mt-1">Yönetim Paneli</p>
        </div>
        <nav className="flex-1 p-4">
          {navItems.filter((item) => !item.module || hasModule(currentUser, item.module)).map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-1 text-sm font-medium transition-colors ${
                isActive(item.path)
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <span>{item.icon}</span>
              {item.label}
            </Link>
          ))}

          {currentUser.is_admin && (
            <div>
              <div className="text-xs text-gray-400 uppercase font-semibold px-4 py-2 mt-3">Yönetim</div>
              {adminItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-1 text-sm font-medium transition-colors ${
                    location.pathname === item.path
                      ? 'bg-red-50 text-red-600'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <span>{item.icon}</span>
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </nav>
        <div className="p-4 border-t">
          <div className="px-4 py-2 text-xs text-gray-500 mb-1">
            {currentUser.full_name || currentUser.email}
            {currentUser.is_admin && <span className="ml-1 text-red-500">(Admin)</span>}
          </div>
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-3 rounded-lg text-sm text-red-500 hover:bg-red-50 font-medium"
          >
            🚪 Çıkış Yap
          </button>
        </div>
      </div>
      <div className="flex-1 p-8 overflow-auto">
        {children}
      </div>
    </div>
  );
}
